module.exports = __webpack_public_path__ + "static/media/Jamie Notter Headshot.4a6fdddd.jpeg";